import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { ContextGroupProps } from '../../../types/common/task-context'

const ContextGroupContainer = styled.div`
  padding: 0 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`

const Title = styled.h6`
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
  margin-bottom: 0.5rem;

  :first-letter {
    text-transform: capitalize;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.25rem;
`

const Key = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  text-transform: capitalize;
  border-bottom: 0px!important;
`

const Value = styled.div`
  font-size: 0.875rem;
  color: #111827;
  text-align: right;
  font-weight: 400;
  word-break: break-word;
  max-width: 60%;
`

const ContextGroup = ({ title, context, t }: ContextGroupProps) => (
  <ContextGroupContainer>
    <Title>{title}</Title>
    {Object.keys(context).map((key) => (
      <Row key={key}>
        <Key>{t(key)}</Key>
        <Value>{context[key]}</Value>
      </Row>
    ))}
  </ContextGroupContainer>
)

export default withTranslation('inbox')(ContextGroup)
